import { render, staticRenderFns } from "./Consent.vue?vue&type=template&id=2853bbaa&"
import script from "./Consent.vue?vue&type=script&lang=ts&"
export * from "./Consent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports